<template>
  <!-- 统计数据显示 -->
  <div class="data-statistic" :style="{'---item-width': itemWidth}">
    <div class="top-count-item card" v-for="(item, idx) in dataList" :key="idx">
      <div class="name"><slot name="name" :data="item">{{item.itemName}}</slot></div>
      <div class="count"><slot name="count" :data="item">{{item.itemCount}}</slot></div>
      <div class="amount"><slot name="desc" :data="item">{{item.desc}}</slot></div>
    </div>
  </div>
</template>

<script>

import {watch} from "vue";

export default {
  emits: ["click"],
  props: {
    dataList: {
      type: Array,
      default:  () =>{ // {itemName, itemCount, desc}
        return [];
      }
    }
  },

  name: "BDC",
  components: {
  },
  data() {
    return {
      itemWidth: "",
    };
  },
  created() {
    this.initWidth();
    watch(() => this.dataList, () => this.initWidth())
  },
  mounted() {

  },
  unmounted() {
  },
  methods: {
    initWidth() {
      this.itemWidth = Math.floor(90 / this.dataList.length) + "%";
    }
  }
};
</script>

<style lang="scss" scoped>
.data-statistic{
  height: 120px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  .top-count-item{
    width: var(---item-width);
    .name{
      color: var(--yq-font-color-desc);
    }
    .count{
      font-size: 26px;
    }
    .amount{
      border-top: 1px solid var(--yq-border-color);
      line-height: 32px;
      color: var(--yq-font-color-desc);
    }
  }
  .card{
    background: #FFF;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 20px;
  }
}
</style>